import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {ActivatedRoute} from '@angular/router';
import {ProfessionalLiabilityService} from '../../../../domain/model/liability/professional-liability.service';
import {ProfessionalLiability} from '../../../../domain/model/liability/professional-liability.model';
import {DisciplinaryActions} from '../../../../domain/model/liability/disciplinary-actions.model';
import {FileListComponentModel} from '../../../../components/files/file-list/file-list.component';
import {FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {FileUploaderComponentModel} from '../../../../components/files/file-uploader/file-uploader.component';
import {Model} from '../../../../domain/model/common/model.class';
import {FileListService} from '../../../../components/files/service/file-list.service';
import ProjectionInformation = Model.ProjectionInformation;

@Component({
    template: require('./disciplinary-actions-screen.component.html')
})
export class DisciplinaryActionsScreenComponent {

    constructor(readonly modelService: ProfessionalLiabilityService,
                readonly route: ActivatedRoute,
                readonly fileListService: FileListService,
                readonly fileLocationFactory: FileLocationFactory) {

        this.fileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<ProfessionalLiability>({
        initialDataModel: new ProfessionalLiability(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel(DisciplinaryActions.projectionInformation);
        },
        _submitDataFn: (model: ProfessionalLiability) => {
            return this.modelService.updateCurrentUserModel(model);
        }
    });

    fileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('disciplinaryActionsSupportingDocument'))
    });

    fileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('disciplinaryActionsSupportingDocuments'))
    });

    get model(): DisciplinaryActions {
        return this.stepScreenModel.dataModel.disciplinaryActions;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    private _refreshFilesInfo() {
        this.fileListService.list(this.fileUploaderModel.filesLocation).subscribe(files => this.fileListModel.files = files);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/liability/steps/disciplinary-actions/disciplinary-actions-screen.component.ts